import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=421edc34"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&id=421edc34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports